import React from 'react';
import { useNavigate } from 'react-router-dom';

import styled from '@emotion/styled';

interface IFullTextLogo {
  className?: string;
}
const FullTextLogo: React.FC<IFullTextLogo> = ({ className }) => {
  const navigate = useNavigate();

  return (
    <Container
      className={className === 'header' ? className : ''}
      onClick={() => navigate('/')}
    >
      <img src="/static/svg/companyLogo.svg" alt="Company" />
    </Container>
  );
};

export default FullTextLogo;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 9.83231rem;
  cursor: pointer;

  &.header {
    width: 6.55488rem;
  }
`;
